import { Component, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { BotoneraApiService } from '../botonera.api.service';
import { IAnularDocumento } from '../botonera.interface';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-anular-documentos',
  standalone: true,
  imports: [Button, FormsModule, TextareaModule],
  templateUrl: './modal-anular-documentos.component.html',
  styleUrl: './modal-anular-documentos.component.scss',
})
export class ModalAnularDocumentosComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  apiService = inject(BotoneraApiService);
  
  motivoAnulacion = '';
  request: IAnularDocumento;

 constructor() {
    this.request = this.config.data;
  }

  async confirmarAnulacion() {
    // recoge el motivo
    this.request.Motivo = this.motivoAnulacion;

    // envia la solicitud al API
    const response = await lastValueFrom(this.apiService.PostAnularDocumento(this.request));

    // cierra el modal retornando la respuesta
    this.ref.close(response);
  }

  cancelarModal() {
    this.ref.close(false);
  }
}
